import { render, staticRenderFns } from "./WizardNumberStep.vue?vue&type=template&id=388d8ad3&scoped=true"
import script from "./WizardNumberStep.vue?vue&type=script&lang=js"
export * from "./WizardNumberStep.vue?vue&type=script&lang=js"
import style0 from "./WizardNumberStep.vue?vue&type=style&index=0&id=388d8ad3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388d8ad3",
  null
  
)

export default component.exports